import styled from 'styled-components';
import { changeColorAlpha, Show } from '@elfsight/lib-utils';
import { useSettings } from '@wu/widget-core';
import { meta } from '../../meta';

export function Header() {
  const {
    windowPicture,
    windowName,
    windowCaption,
    windowTextColor,
    windowNameFontSize,
    windowCaptionFontSize
  } = useSettings();
  const imageUrl = windowPicture?.url;

  if (!windowPicture && !windowName && !windowCaption) {
    return null;
  }

  return (
    <Component>
      <Show when={!!imageUrl}>
        <Image _imageUrl={imageUrl} />
      </Show>

      <Show when={!!windowName}>
        <Title
          _color={windowTextColor}
          _fontSize={windowNameFontSize}
          _hasImage={!!imageUrl}
        >
          {windowName}
        </Title>
      </Show>

      <Show when={!!windowCaption}>
        <Caption
          _color={changeColorAlpha(windowTextColor, -0.3)}
          _fontSize={windowCaptionFontSize}
        >
          {windowCaption}
        </Caption>
      </Show>
    </Component>
  );
}

const Component = styled.div.attrs({
  className: `${meta.prefix}-header-component`
})`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const Image = styled.div.attrs({
  className: `${meta.prefix}-header-image`
})`
  width: 56px;
  height: 56px;
  flex-shrink: 1;
  flex-grow: 0;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 50%;
  position: relative;
  background-image: ${({ _imageUrl }) =>
    _imageUrl ? `url(${_imageUrl})` : 'none'};

  &:after {
    border-radius: 50%;
    border: 1px solid rgba(0, 0, 0, 0.1);
    inset: 0;
    position: absolute;
    content: '';
    overflow: hidden;
  }
`;

const Title = styled.div.attrs({
  className: `${meta.prefix}-header-title`
})`
  font-size: ${({ _fontSize }) => _fontSize}px;
  font-weight: 700;
  text-align: center;
  margin-top: ${({ _hasImage }) => (_hasImage ? '12px' : '0')};
  color: ${({ _color }) => _color};
`;

const Caption = styled.div.attrs({
  className: `${meta.prefix}-header-caption`
})`
  font-size: ${({ _fontSize }) => _fontSize}px;
  text-align: center;
  margin-top: 4px;
  text-transform: uppercase;
  color: ${({ _color }) => _color};
`;
